import { Grid, Skeleton } from '@mui/material'

export function AppLessonSkeleton({ isListMode }: { isListMode: boolean }) {
  return (
    <>
      {!isListMode ? (
        <>
          <Grid item xs={2} sm={4} md={4}>
            <Skeleton variant="rounded" width={'95%'} height={185} />
          </Grid>
          <Grid item xs={2} sm={4} md={4}>
            <Skeleton variant="rounded" width={'95%'} height={185} />
          </Grid>
          <Grid item xs={2} sm={4} md={4}>
            <Skeleton variant="rounded" width={'95%'} height={185} />
          </Grid>
        </>
      ) : (
        <>
          <Skeleton
            variant="rounded"
            sx={{ mb: 1 }}
            width={'100%'}
            height={68}
          />
          <Skeleton
            variant="rounded"
            sx={{ mb: 1 }}
            width={'100%'}
            height={68}
          />
          <Skeleton
            variant="rounded"
            sx={{ mb: 1 }}
            width={'100%'}
            height={68}
          />
        </>
      )}
    </>
  )
}
